import React, {useState} from "react";

export const Input = (props) => {
  const setTrim = (e) => {
    let input = document.getElementById(props.name);
    if (input as HTMLInputElement) {
      (input as HTMLInputElement).value = e.trim();
    }
  };
  const hidelabel = props.hidelabel ? props.hidelabel : false;
  const [password, setPassword] = useState('password');
  const labelFor = (!props.id) ? props.name : props.id;
  return (
    <>
      <div className={`field text_wrap ${props.name.replace(".", "_")} ${(props.errors && props.errors[props.name]) ? 'error' : ''}`}>
        
        {hidelabel === false && <label htmlFor={props.type === 'radio' ? `${labelFor}_${props.value}` : labelFor} className="title" dangerouslySetInnerHTML={{ __html: props.title }}></label>}
        {props.type === 'textarea' ?
          <textarea
            {...props}
            type={props.type !== 'password' ? props.type : password}
            id={labelFor}
            autoComplete={`new-${props.name}`}
            onBlur={(e) => setTrim(e.target.value)}
            onChange={props.onChange}
            {...props.register}
          />
        :
        props.type === 'checkbox' ?
          <label className="checkbox">
            <input
              {...props}
              type='checkbox'
              onChange={props.onChange}
              {...props.register}
            />
            <span>{props.placeholder}</span>

          </label>
        :
          <input
            {...props}
            type={props.type !== 'password' ? props.type : password}
            id={props.type === 'radio' ? `${labelFor}_${props.value}` : labelFor}
            autoComplete={`new-${props.name}`}
            onBlur={(e) => setTrim(e.target.value)}
            onChange={props.onChange}
            {...props.register}
          />
        }
        {props.type === 'password' && <span className="eyePassword" onClick={()=>setPassword(password==='password' ? 'text' : 'password')}></span>}
        {(props.errors && props.errors[props.name]) && <span className="error">{props.errors[props.name].message}</span>}
      </div>
    </>
  );
};
